<table class="table table-bordered table-hover table-responsive sticky-header mb-0">
  <thead>
    <tr class="table-active border-none">
      <th scope="col" class="report-header-cell text-center align-middle" style="width: 60px;">
        <div class="d-flex justify-content-center align-items-center">
          <b class="report-header-text">Sr. No.</b>
        </div>
      </th>
      <th scope="col" class="report-header-cell text-center align-middle report-sortable" (click)="sortBy('Topic_Sort_Order')">
        <div class="d-flex justify-content-center align-items-center">
          <b class="report-header-text">Topic Name</b>
          <i
            *ngIf="isSortFieldActive('Topic_Sort_Order')"
            class="ms-2 fa report-sort-icon"
            [class.sort-active]="isSortFieldActive('Topic_Sort_Order')"
            [ngClass]="getSortIconClass('Topic_Sort_Order')"
          ></i>
        </div>
      </th>
      <th scope="col" class="report-header-cell text-center align-middle">
        <div class="d-flex justify-content-center align-items-center">
          <b class="report-header-text">Study Unit Name</b>
        </div>
      </th>
      <th scope="col" class="report-header-cell text-center align-middle">
        <div class="d-flex justify-content-center align-items-center">
          <b class="report-header-text">Study Material Name</b>
        </div>
      </th>
      <th class="report-header-cell text-center align-middle report-sortable" (click)="sortBy('Number_Of_Questions')">
        <div class="d-flex justify-content-center align-items-center">
          <b class="report-header-text">Number of Questions</b>
          <i
            *ngIf="isSortFieldActive('Number_Of_Questions')"
            class="ms-2 fa report-sort-icon"
            [class.sort-active]="isSortFieldActive('Number_Of_Questions')"
            [ngClass]="getSortIconClass('Number_Of_Questions')"
          ></i>
        </div>
      </th>
      <th class="report-header-cell text-center align-middle report-sortable report-practice-question-header" (click)="sortBy('Number_of_Practice_Questions')">
        <div class="d-flex justify-content-center align-items-center">
          <b class="report-header-text report-practice-question-text">Number of Practice Questions</b>
          <i
            *ngIf="isSortFieldActive('Number_of_Practice_Questions')"
            class="ms-2 fa report-sort-icon"
            [class.sort-active]="isSortFieldActive('Number_of_Practice_Questions')"
            [ngClass]="getSortIconClass('Number_of_Practice_Questions')"
          ></i>
        </div>
      </th>
      <th class="report-header-cell text-center align-middle report-sortable" (click)="sortBy('Percentage_of_Practice_Questions')">
        <div class="d-flex justify-content-center align-items-center">
          <b class="report-header-text">% of Practice Questions</b>
          <i
            *ngIf="isSortFieldActive('Percentage_of_Practice_Questions')"
            class="ms-2 fa report-sort-icon"
            [class.sort-active]="isSortFieldActive('Percentage_of_Practice_Questions')"
            [ngClass]="getSortIconClass('Percentage_of_Practice_Questions')"
          ></i>
        </div>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of sortedRows; let i = index">
      <td class="text-center align-middle">{{ i + 1 }}</td>
      <td class="text-start report-text-column">
        {{ row.Topic_Name }} ({{ row.Topic_Sort_Order }})
      </td>
      <td class="text-start report-text-column">
        <a href="javascript:void(0)" title="Edit Study Unit" (click)="onEditStudyUnit(row)">
          {{ row.Study_Unit_Name }}
          ({{ row.Study_Unit_Display_Order || row.Study_Unit_Id }})
        </a>
      </td>
      <td class="text-start report-text-column">
        <span *ngIf="row.Study_Material_Name" class="d-inline-flex align-items-center" style="white-space: nowrap;">
          <a href="javascript:void(0)" title="Edit Study Material" (click)="onEditStudyMaterial(row)">
            {{ row.Study_Material_Name }}
          </a>
          <i
            class="fa fa-info-circle ms-1"
            [ngStyle]="{ color: isTestNotesFile(row.File_Name) ? 'red' : '#0c4788' }"
            [title]="row.File_Name"
          ></i>
        </span>
      </td>
      <td class="text-center">{{ row.Number_Of_Questions }}</td>
      <td class="text-center">
        <a href="javascript:void(0)" title="Assign Practice Questions" (click)="onAssignPracticeQuestion(row)">
          {{ row.Number_of_Practice_Questions }}
        </a>
      </td>
      <td class="text-center">{{ row.Percentage_of_Practice_Questions }}</td>
    </tr>
    <tr *ngIf="sortedRows.length === 0">
      <td colspan="7" class="text-center">No report data found.</td>
    </tr>
  </tbody>
</table>
